<script>
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  const currentYear = new Date().getFullYear().toString();
  const isPrivacyLinkEnabled = flagValue(FEATURE_FLAGS.PRIVACY_LINK);
</script>

<div>
  <span>
    {`© ${currentYear}  Block, Inc. BLOCK and the Block Logo are trademarks of Block, Inc.`}
  </span>
  <a href="/legal" rel="noreferrer noopener" tabIndex="0" data-sveltekit-reload> Legal. </a>
  {#if isPrivacyLinkEnabled}
    <a href="/legal/privacy-notice" rel="noreferrer noopener" tabIndex="0" data-sveltekit-reload>
      Privacy.
    </a>
  {/if}
</div>

<style lang="scss">
  @import 'src/scss/landing.scss';

  div {
    font-family: var(--font-family-primary);
    font-weight: normal;
    font-size: 10px;
    font-style: normal;
    padding-right: 12px;
    line-height: 1.4;
    color: var(--twist-color-gray-100);
    display: block;
  }

  a {
    @include clickable;
    @include animatedLink(1px);
    font-weight: 600;
    display: inline;
    position: relative;
  }

  @media screen and (min-width: 375px) {
    div {
      padding-right: 30px;
    }
  }

  @media screen and (min-width: 768px) {
    div {
      max-width: 280px;
    }
  }

  @media screen and (min-width: 1024px) {
    div {
      padding-right: 0;
      span {
        letter-spacing: 0.02em;
      }
    }
  }

  @media screen and (min-width: 1400px) {
    div {
      max-width: unset;
    }
  }
</style>
